import React from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import createLogger from 'redux-logger'
import App from './components/App'

// Prepare the coursenum for initial store state
const pathArray = window.location.pathname.split('/')
const coursenum = pathArray[3]

const defaultState = {
  coursenum,
  canvasCoursenum: '',
  canvasUrl: '',
  courseTitle: '',
  courseToken: '',
  courseList: [],
  launchToolCreated: '',
  selectedLms: '',
  assessments: {},
  formErrorMsg: '',
  msgClass: 'danger',
  selectErrorMsg: '',
}

const rootReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'CHOOSE_LMS': // only used when we start using the LMSChooser Component
      return {
        ...state,
        lms: action.payload,
      }
    case 'UPDATE_LMS_DATA':
      return {
        ...state,
        canvasCoursenum: action.canvasCoursenum,
        canvasUrl: action.canvasUrl,
        courseTitle: action.courseTitle,
      }
    case 'UPDATE_LMS_TOKEN':
      return {
        ...state,
        courseToken: action.courseToken,
      }
    case 'SET_LMS_COURSE_LIST':
      return {
        ...state,
        courseList: action.courseList,
      }
    case 'UPDATE_LAUNCH_TOOL_CREATED':
      return {
        ...state,
        launchToolCreated: action.launchToolCreated,
      }
    case 'UPDATE_SELECTED_LMS':
      return {
        ...state,
        selectedLms: action.selectedLms,
      }
    case 'UPDATE_ASSESSMENTS':
      return {
        ...state,
        assessments: action.assessments,
      }
    case 'UPDATE_BRIGHTSPACE_CONFIGURATION':
      return {
        ...state,
        brightspaceAKPConfigured: action.configured,
      }
    case 'UPDATE_FORM_ERROR':
      return {
        ...state,
        formErrorMsg: action.formErrorMsg,
        msgClass: action.msgClass,
      }
    case 'UPDATE_SELECT_FORM_ERROR':
      return {
        ...state,
        selectErrorMsg: action.selectErrorMsg,
      }
    default:
      return state
  }
}

const middlewares =
  process.env.NODE_ENV === 'production'
    ? applyMiddleware(thunk)
    : applyMiddleware(thunk, createLogger())
let appStore = compose(middlewares)(createStore)(rootReducer)

const giveComponentDispatchContext = (WrappedComponent, store) => {
  return class TempComponent extends React.Component {
    static childContextTypes = {
      store: PropTypes.object,
    }

    getChildContext() {
      return { store }
    }

    render() {
      return <WrappedComponent {...this.props} />
    }
  }
}

const render = Component => {
  let appNode = document.getElementById('app')
  ReactDOM.render(<Component storeState={appStore.getState()} />, appNode)
}

export let startLmsApp = () => {
  let PreparedComponent = giveComponentDispatchContext(App, appStore)
  render(PreparedComponent)
}
